import { render, staticRenderFns } from "./TreatmentArchivesForm.vue?vue&type=template&id=1fb40f20&"
import script from "./TreatmentArchivesForm.vue?vue&type=script&lang=js&"
export * from "./TreatmentArchivesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports